"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.BookingInfo = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _react = _interopRequireDefault(require("react"));
var _Schedule = _interopRequireDefault(require("@kyruus/react-ikons/Schedule"));
var _globals = require("../../../../lib/constants/globals");
var _messages = _interopRequireDefault(require("../../../../lib/constants/messages"));
var _infoLine = _interopRequireDefault(require("../../../InfoLine/info-line"));
var _styles = require("../../styles");
// filter out any availability_density_best larger than this number.
// Search team uses extraordinarily large numbers for sort purposes but
// we don't actually want to show those large numbers in the UI
const MAX_ADB = 60;
const BookingInfo = _ref => {
  var _context, _context2;
  let {
    provider,
    shouldDisplayAvailability,
    slotsStatus,
    config
  } = _ref;
  const providerWillRenderAvailTiles = provider.locations ? (0, _filter.default)(_context = provider.locations).call(_context, _ref2 => {
    let {
      slots = false
    } = _ref2;
    return slots;
  }).length > 0 : false;

  // get the last item in `sort` with a valid `availability_density_best` member
  const providerAvailDensityBest = (0, _reduce.default)(_context2 = (0, _sort.default)(provider) || []).call(_context2, (acc, sortItem) => {
    if (sortItem.availability_density_best && sortItem.availability_density_best < MAX_ADB) {
      return sortItem.availability_density_best;
    }
    return acc;
  }, null);

  // whether or not to show "available in X days"
  let showAvailabilityDensityBest = true;
  if (shouldDisplayAvailability) {
    if (slotsStatus !== _globals.SLOTS_SUCCESS_STATUS) {
      // if avail tiles are enabled, but slots have not been fetched, suppress the text.
      // When avail tiles are active, we should only display the text when there is no
      // availability from slots
      showAvailabilityDensityBest = false;
    }
    if (providerWillRenderAvailTiles) {
      // if we have slots data for avail tiles, suppress the text
      showAvailabilityDensityBest = false;
    }
  }
  const showAvailableWithinDays = !config?.hide_availability_density;
  return /*#__PURE__*/_react.default.createElement(_styles.BookingInfoContainer, {
    "data-testid": "BookingInfo"
  }, showAvailableWithinDays && providerAvailDensityBest && showAvailabilityDensityBest && /*#__PURE__*/_react.default.createElement(_infoLine.default, {
    Icon: _Schedule.default,
    infoMessage: _messages.default.availability,
    values: {
      days: providerAvailDensityBest
    },
    afterText: "*"
  }));
};
exports.BookingInfo = BookingInfo;
BookingInfo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BookingInfo"
};